import { HttpClient } from "../http";

export interface ReplyRule {
  id: string;
  accountId: string;
  keyword: string;
  replyText: string;
  buttonLabel?: string;
  buttonUrl?: string;
  imageUrl?: string;
  subtitle?: string;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export class RulesService extends HttpClient {
  constructor() {
    super(process.env.NEXT_PUBLIC_API_URL!);
  }

  async getRules(accountId: string) {
    return this.get<ReplyRule[]>(`/api/instagram/accounts/${accountId}/rules`);
  }

  async getRule(accountId: string, ruleId: string) {
    return this.get<ReplyRule>(`/api/instagram/accounts/${accountId}/rules/${ruleId}`);
  }

  async createRule(accountId: string, data: Partial<ReplyRule>) {
    return this.post<ReplyRule>(`/api/instagram/accounts/${accountId}/rules`, data);
  }

  async updateRule(accountId: string, ruleId: string, data: Partial<ReplyRule>) {
    return this.patch<ReplyRule>(`/api/instagram/accounts/${accountId}/rules/${ruleId}`, data);
  }

  async deleteRule(accountId: string, ruleId: string) {
    return this.delete<{ success: boolean }>(`/api/instagram/accounts/${accountId}/rules/${ruleId}`);
  }

  async toggleRule(accountId: string, ruleId: string) {
    return this.patch<ReplyRule>(`/api/instagram/accounts/${accountId}/rules/${ruleId}/toggle`);
  }

  async getStats(accountId: string) {
    return this.get<{
      total: number;
      active: number;
      matched: number;
    }>(`/api/instagram/accounts/${accountId}/rules/stats`);
  }
}